import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    title: "Chennai Super Kings(CSK) Jersey",
    price: "1780",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796157/cricify/ipl/csk-match-jersey-2023-dhoni-1599-front_noeimy.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796157/cricify/ipl/csk-match-jersey-2023-dhoni-1599-back_mecgrz.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796157/cricify/ipl/csk-match-jersey-2023-dhoni-1599-back-front_am88y0.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: true,
    men: true,
    women: false,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Kolkata Knight Riders - Luggage Bag Tags Pack of - 1",
    price: "231",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 3.3,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Kolkata_Knight_Riders_-_Luggage_Bag_Tags_Pack_of_-_1_-231_ymfjeh.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Kolkata_Knight_Riders_-_Luggage_Bag_Tags_Pack_of_-_1_-231_ymfjeh.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Kolkata_Knight_Riders_-_Luggage_Bag_Tags_Pack_of_-_1_-231_ymfjeh.jpg",
    ],
    description: ["Very stylish"],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "India 2003-06 Jersey",
    price: "2099",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 4.1,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866681/cricify/ind-2003-2006-jersey-1999_fbbma3.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866681/cricify/ind-2003-2006-jersey-1999_fbbma3.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866681/cricify/ind-2003-2006-jersey-1999_fbbma3.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: true,
  },
  {
    _id: uuid(),
    title: "Sports Gym Bag CSK",
    price: "1699",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/Sports_Gym_Bag_CSK-1699_pocypb.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/Sports_Gym_Bag_CSK-1699_pocypb.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/Sports_Gym_Bag_CSK-1699_pocypb.jpg",
    ],
    description: [
      "Very comforting",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: true,
    men: true,
    women: true,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Women Blue White Mi - Official Slider Flip Flops",
    price: "999",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/Women_s_Blue_White_Mi-_Official_Slider_Flip_Flops-999_hpkbd8.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/Women_s_Blue_White_Mi-_Official_Slider_Flip_Flops-999_hpkbd8.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/Women_s_Blue_White_Mi-_Official_Slider_Flip_Flops-999_hpkbd8.jpg",
    ],
    description: [
      "Very comforting",
      "Fit Type: Regular",
      "Care Instructions:-Wipe with a clean dry cloth",
    ],
    inStock: true,
    isTrending: true,
    men: false,
    women: true,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Chennai Super Kings - Yellove Sipper",
    price: "799",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 3.8,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Chennai_Super_Kings_-_Yellove_Sipper-799_cmknc8.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Chennai_Super_Kings_-_Yellove_Sipper-799_cmknc8.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Chennai_Super_Kings_-_Yellove_Sipper-799_cmknc8.jpg",
    ],
    description: ["Material: Plastic", "Capacity: 0.7L"],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "SG Full Cricket Kit Combo",
    price: "26299",
    categoryName: "gears",
    size: "One Size - Free Size",
    rating: 4.9,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796138/cricify/accessories/SG_Full_Cricket_Kit_Combo_awljtl.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796138/cricify/accessories/SG_Full_Cricket_Kit_Combo_awljtl.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796138/cricify/accessories/SG_Full_Cricket_Kit_Combo_awljtl.jpg",
    ],
    description: [
      "Complete Kit bag which includes all the gear that you need",
      "Very comforting",
      "Kitbag made from heavy duty nylon material",
      "Cricket Kit Includes Items:-Cricket Bat with cover + Legguard + Batting Gloves + Kitbag + Thigh Guard + Arm Guard + Abdo Guard",
    ],
    inStock: true,
    isTrending: true,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Royal Challengers Bangalore(RCB) Jersey",
    price: "1399",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 4.5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796160/cricify/ipl/rcb-match-jersey-2023-virat-1299-front_ncqvxd.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796160/cricify/ipl/rcb-match-jersey-2023-virat-1299-back_ui8kpb.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796160/cricify/ipl/rcb-match-jersey-2023-virat-1299-back-front_k19wao.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: true,
    men: true,
    women: false,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "GT-Training Jacket",
    price: "1799",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 4.2,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/GT-Training_Jacket-1799_rbbdcp.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/GT-Training_Jacket-1799_rbbdcp.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/GT-Training_Jacket-1799_rbbdcp.jpg",
    ],
    description: [
      "Material: Polyester",
      "Very comforting",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "LSG The Super Giants - Square Pillows",
    price: "399",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 3.9,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/LSG_The_Super_Giants_-_Square_Pillows-399_ur12ps.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/LSG_The_Super_Giants_-_Square_Pillows-399_ur12ps.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/LSG_The_Super_Giants_-_Square_Pillows-399_ur12ps.jpg",
    ],
    description: [
      "Very comforting",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "India 2022-23 Jersey",
    price: "2499",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 4.1,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685918957/cricify/ind-jersey-22-23-front-2499_jlu4zu.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866681/cricify/ind-jersey-22-23-front-back-2499_h3vpla.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866681/cricify/ind-jersey-22-23-front-back-2499_h3vpla.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: false,
    ipl: false,
    wpl: false,
    international: true,
  },
  {
    _id: uuid(),
    title: "MI-Official New Era 9Fifty Cap-Navy",
    price: "1699",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/MI-Official_New_Era_9Fifty_Cap-Navy-1699_lv6uac.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/MI-Official_New_Era_9Fifty_Cap-Navy-1699_lv6uac.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/MI-Official_New_Era_9Fifty_Cap-Navy-1699_lv6uac.jpg",
    ],
    description: [
      "Very comforting",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: false,
    isTrending: true,
    men: true,
    women: true,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "India 1985 Fan Jersey",
    price: "1399",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 3.9,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866681/cricify/ind-1985-fan-jersey-1399_fbtvlz.png",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866681/cricify/ind-1985-fan-jersey-1399_fbtvlz.png",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866681/cricify/ind-1985-fan-jersey-1399_fbtvlz.png",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: false,
    ipl: false,
    wpl: false,
    international: true,
  },
  {
    _id: uuid(),
    title: "SS Ton Reserve Edition English Willow Short Handle Cricket Bat",
    price: "39999",
    categoryName: "gears",
    size: "One Size - Free Size",
    rating: 4.8,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685940029/cricify/accessories/SS_Ton_Reserve_Edition_English_Willow_Short_Handle_Cricket_Bat-39999_kb0hwe.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685940029/cricify/accessories/SS_Ton_Reserve_Edition_English_Willow_Short_Handle_Cricket_Bat-39999_kb0hwe.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685940029/cricify/accessories/SS_Ton_Reserve_Edition_English_Willow_Short_Handle_Cricket_Bat-39999_kb0hwe.jpg",
    ],
    description: [
      "Grade- Selected grade 1 world’s finest English willow hard pressed & traditionally shaped for superb stroke",
      "Grains- 8-10 straight grains",
      "Handle-Singapore cane handle with special 3 way insertion of cork in between splits for enhanced flexibility and shock absorption",
      "Handle Shape-Traditional round cane handle for supreme grip and overall bat control",
      "Weight-1160-1180 gm(2.9-2.10 lbs)",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: true,
    wpl: true,
    international: true,
  },
  {
    _id: uuid(),
    title: "India 2007 T20 WC Jersey",
    price: "3999",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866680/cricify/ind-2007-t20-wc-jersey-2099_aowuv3.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866680/cricify/ind-2007-t20-wc-jersey-2099_aowuv3.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866680/cricify/ind-2007-t20-wc-jersey-2099_aowuv3.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: false,
    isTrending: true,
    men: true,
    women: false,
    ipl: false,
    wpl: false,
    international: true,
  },
  {
    _id: uuid(),
    title: "DSC Condor Atmos Leather Cricket Batting Gloves",
    price: "910",
    categoryName: "gears",
    size: "One Size - Free Size",
    rating: 1.9,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796136/cricify/accessories/DSC_Condor_Atmos_Leather_Cricket_Batting_Gloves-910_ighvtk.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796136/cricify/accessories/DSC_Condor_Atmos_Leather_Cricket_Batting_Gloves-910_ighvtk.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796136/cricify/accessories/DSC_Condor_Atmos_Leather_Cricket_Batting_Gloves-910_ighvtk.jpg",
    ],
    description: [
      "Performance: quality Batting Gloves in lightweight series, superior grip and feather light feel",
      "Specifications: multi- flex pre-curved construction in the lead fingers, strategically positioned flex points for unrestricted movements",
      "Features: - reinforced plastic fibres in the fingers– impact protection, airflow gusset for moisture absorption and player’s comfort",
      "Ideal for: players looking for lightweight gloves for good fit and protection",
      "Playing levels: juniors, beginners and recreational players",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "India 2011 WC Jersey",
    price: "3999",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866681/cricify/ind-2011-wc-jersey-back-3999_z2yapm.png",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866680/cricify/ind-2011-wc-jersey-3999_uvi2gc.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866680/cricify/ind-2011-wc-jersey-3999_uvi2gc.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: false,
    isTrending: true,
    men: true,
    women: false,
    ipl: false,
    wpl: false,
    international: true,
  },
  {
    _id: uuid(),
    title: "LSG Gazab Andaz - Fridge Magnets",
    price: "199",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 2.9,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/LSG_Gazab_Andaz_-_Fridge_Magnets-199_k2ef0r.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/LSG_Gazab_Andaz_-_Fridge_Magnets-199_k2ef0r.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796122/cricify/fan-merchandise/LSG_Gazab_Andaz_-_Fridge_Magnets-199_k2ef0r.jpg",
    ],
    description: ["Very attractive", "Material: Plastic and Magnet"],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Rajasthan Royals(RR) Jersey",
    price: "1092",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 3.4,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796161/cricify/ipl/rr-match-jersey-2023-sanju-1092-front_wtl4bm.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796160/cricify/ipl/rr-match-jersey-2023-sanju-1092-back_q45n8m.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796160/cricify/ipl/rr-match-jersey-2023-sanju-1092-back-front_lxx2gp.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: false,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "ICC T20 Black Backpack",
    price: "715",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 3.4,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/icc-t20-black-backpack-715_ki5orc.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/icc-t20-black-backpack-715_ki5orc.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/icc-t20-black-backpack-715_ki5orc.jpg",
    ],
    description: [
      "Very comforting",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: true,
  },
  {
    _id: uuid(),
    title: "RCB Travel Polo Womens",
    price: "1199",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 2.9,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/RCB_Travel_Polo_Womens_-1199_p2khvg.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/RCB_Travel_Polo_Womens_-1199_p2khvg.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/RCB_Travel_Polo_Womens_-1199_p2khvg.jpg",
    ],
    description: [
      "Very comforting",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: false,
    women: true,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "India Blue Black String Bag",
    price: "379",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 4.6,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/india-unisex-blue-black-string-bag-379_v4h21n.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/india-unisex-blue-black-string-bag-379_v4h21n.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/india-unisex-blue-black-string-bag-379_v4h21n.jpg",
    ],
    description: [
      "Very comforting",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: true,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: true,
  },
  {
    _id: uuid(),
    title: "Sunrisers Hyderabad(SRH) Jersey",
    price: "599",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 2.5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796161/cricify/ipl/srh-match-jersey-2023-599-front_ti6f3x.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796161/cricify/ipl/srh-match-jersey-2023-599-back-front_nymjz3.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796161/cricify/ipl/srh-match-jersey-2023-599-back-front_nymjz3.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: false,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Black Metal Precision Safety Razor - Rajasthan Royals",
    price: "1316",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 1.6,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Black_Metal_Precision_Safety_Razor_-_Rajasthan_Royals-1316_hqsngk.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Black_Metal_Precision_Safety_Razor_-_Rajasthan_Royals-1316_hqsngk.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Black_Metal_Precision_Safety_Razor_-_Rajasthan_Royals-1316_hqsngk.jpg",
    ],
    description: ["Very stylish", "Material: Plastic and Aluminium"],
    inStock: true,
    isTrending: false,
    men: true,
    women: false,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Punjab Kings(PK) Jersey",
    price: "699",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 2.7,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796160/cricify/ipl/punjab-match-jersey-2023-zinta-799-back-front_ckph5r.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796160/cricify/ipl/punjab-match-jersey-2023-zinta-799-back-front_ckph5r.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796160/cricify/ipl/punjab-match-jersey-2023-zinta-799-back-front_ckph5r.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: false,
    isTrending: false,
    men: true,
    women: false,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Sunrisers Hyderabad - Acrylic Keychains Pack of - 2",
    price: "182",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 4.7,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Sunrisers_Hyderabad_-_Acrylic_Keychains_Pack_of_-_2_-182_wvz5tk.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Sunrisers_Hyderabad_-_Acrylic_Keychains_Pack_of_-_2_-182_wvz5tk.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Sunrisers_Hyderabad_-_Acrylic_Keychains_Pack_of_-_2_-182_wvz5tk.jpg",
    ],
    description: ["Very stylish", "Material: Plastic and Aluminium"],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Rajasthan Royals - Tote Bags Pack of - 1",
    price: "239",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 3.1,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Rajasthan_Royals_-_Tote_Bags_Pack_of_-_1_-239_iliqat.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Rajasthan_Royals_-_Tote_Bags_Pack_of_-_1_-239_iliqat.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Rajasthan_Royals_-_Tote_Bags_Pack_of_-_1_-239_iliqat.jpg",
    ],
    description: ["Very stylish"],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Lucknow Super Giants(LSG) Jersey",
    price: "899",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 3.9,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796159/cricify/ipl/lsg-match-jersey-2023-rahul-899-front_bqbc4z.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796159/cricify/ipl/lsg-match-jersey-2023-rahul-899-back_ysquiu.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796159/cricify/ipl/lsg-match-jersey-2023-rahul-899-back-front_ounxgx.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: false,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Kolkata Knight Riders(KKR) Jersey",
    price: "1399",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 4.3,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796158/cricify/ipl/kkr-match-jersey-2023-1304-front_w2fx9h.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796158/cricify/ipl/kkr-match-jersey-2023-1304-back-front_fblla1.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796158/cricify/ipl/kkr-match-jersey-2023-1304-back-front_fblla1.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: false,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "KOOKABURRA Adult Cricket Bat KB Kahuna 1000",
    price: "41142",
    categoryName: "gears",
    size: "One Size - Free Size",
    rating: 4.5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796136/cricify/accessories/KOOKABURRA_Adult_Cricket_Bat_KB_Kahuna_1000-41142_dejeaj.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796136/cricify/accessories/KOOKABURRA_Adult_Cricket_Bat_KB_Kahuna_1000-41142_dejeaj.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796136/cricify/accessories/KOOKABURRA_Adult_Cricket_Bat_KB_Kahuna_1000-41142_dejeaj.jpg",
    ],
    description: [
      "Grade- Selected grade 1 world’s finest English willow hard pressed & traditionally shaped for superb stroke",
      "Grains- 8-10 straight grains",
      "Handle-Singapore cane handle with special 3 way insertion of cork in between splits for enhanced flexibility and shock absorption",
      "Handle Shape-Traditional round cane handle for supreme grip and overall bat control",
      "Weight-1160-1180 gm(2.9-2.10 lbs)",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: true,
    wpl: true,
    international: true,
  },
  {
    _id: uuid(),
    title: "Chennai Super Kings - Thala 7 Ceramic Mug",
    price: "399",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 4.9,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Chennai_Super_Kings_-_Thala_7_Ceramic_Mug-399_w3juus.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Chennai_Super_Kings_-_Thala_7_Ceramic_Mug-399_w3juus.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/Chennai_Super_Kings_-_Thala_7_Ceramic_Mug-399_w3juus.jpg",
    ],
    description: ["Material: Ceramic"],
    inStock: true,
    isTrending: true,
    men: true,
    women: true,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Mumbai Indians(MI) Jersey",
    price: "1599",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 4.7,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796160/cricify/ipl/mi-match-jersey-2023-rohit-1099-front_bfsebi.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796160/cricify/ipl/mi-match-jersey-2023-rohit-1099-back_wgcxf9.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796160/cricify/ipl/mi-match-jersey-2023-rohit-1099-back-front_lxiqid.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: true,
    men: true,
    women: false,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "SG Optipro Cricket Helmet",
    price: "2099",
    categoryName: "gears",
    size: "One Size - Free Size",
    rating: 5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_Optipro_Cricket_Helmet-2005_pxjprt.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_Optipro_Cricket_Helmet-2005_pxjprt.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_Optipro_Cricket_Helmet-2005_pxjprt.jpg",
    ],
    description: [
      "Polypropylene high-impact resistant outer shell",
      "Inner shell made from impact reducing foam",
      "Classic four vents for free flow air circulation",
      "Sweat absorbent lining",
      "High impact polypropylene shell",
      "Fully adjustable steel grill for superior protection",
      "Protective impact-resistant and sweat-absorbent with special sweat mesh breathable inner padding",
    ],
    inStock: true,
    isTrending: true,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Royal Challengers Bangalore(RCB) Women Jersey",
    price: "1599",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 4.9,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796148/cricify/wpl/rcb-women-match-jersey-2023-smriti-1299-front_u4o6w3.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796147/cricify/wpl/rcb-women-match-jersey-2023-disha-1299-front_cekvmy.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796147/cricify/wpl/rcb-women-match-jersey-2023-disha-1299-front_cekvmy.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: true,
    men: false,
    women: true,
    ipl: false,
    wpl: true,
    international: false,
  },
  {
    _id: uuid(),
    title: "SG Test Cricket Batting Legguard Batting Pad",
    price: "4499",
    categoryName: "gears",
    size: "One Size - Free Size",
    rating: 4.5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_Test_Cricket_Batting_Legguard_Batting_Pad_-4499_qtkexo.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_Test_Cricket_Batting_Legguard_Batting_Pad_-4499_qtkexo.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_Test_Cricket_Batting_Legguard_Batting_Pad_-4499_qtkexo.jpg",
    ],
    description: [
      "Premium quality imported polyurethane facing",
      "Cotton filled knee rolls with a layer of high density foam reinforcement",
      "High-density sponge filled vertical bolster with TPU insert for knee protection",
      "Extra high-density foam filling in the side wings",
      "Mesh instep with hard-wearing piping",
      "Extra butterfly straps for the right fit",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "UP Warriorz(UPW) Women Jersey",
    price: "999",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 3.8,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796147/cricify/wpl/upw-women-match-jersey-2023-1499-front_swamqb.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796147/cricify/wpl/upw-women-match-jersey-2023-1499-front_swamqb.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796147/cricify/wpl/upw-women-match-jersey-2023-1499-front_swamqb.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: false,
    women: true,
    ipl: false,
    wpl: true,
    international: false,
  },
  {
    _id: uuid(),
    title: "GM 505 Lightweight Cricket Batting Gloves",
    price: "2099",
    categoryName: "gears",
    size: "One Size - Free Size",
    rating: 4.9,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796136/cricify/accessories/GM_505_Lightweight_Cricket_Batting_Gloves-2009_paueeg.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796136/cricify/accessories/GM_505_Lightweight_Cricket_Batting_Gloves-2009_paueeg.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796136/cricify/accessories/GM_505_Lightweight_Cricket_Batting_Gloves-2009_paueeg.jpg",
    ],
    description: [
      "Performance: quality Batting Gloves in lightweight series, superior grip and feather light feel",
      "Specifications: multi- flex pre-curved construction in the lead fingers, strategically positioned flex points for unrestricted movements",
      "Features: - reinforced plastic fibres in the fingers– impact protection, airflow gusset for moisture absorption and player’s comfort",
      "Ideal for: players looking for lightweight gloves for good fit and protection",
      "Playing levels: juniors, beginners and recreational players",
    ],
    inStock: true,
    isTrending: true,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Gujarat Giants(GG) Women Jersey",
    price: "999",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 2,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796147/cricify/wpl/gg-women-match-jersey-2023-999-front_sfprmj.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796147/cricify/wpl/gg-women-match-jersey-2023-999-front_sfprmj.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796147/cricify/wpl/gg-women-match-jersey-2023-999-front_sfprmj.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: false,
    isTrending: false,
    men: false,
    women: true,
    ipl: false,
    wpl: true,
    international: false,
  },
  {
    _id: uuid(),
    title: "SG Test Leather Cricket Ball Red",
    price: "6000",
    categoryName: "gears",
    size: "N/A",
    rating: 4.9,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_test_cricket_leather_ball-red-1799_m1q2w3.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_test_cricket_leather_ball-red-1799_m1q2w3.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_test_cricket_leather_ball-red-1799_m1q2w3.jpg",
    ],
    description: [
      "Good quality centre construction encased with layers of top quality Portuguese cork wound with 100 percent wool",
      "Naturally seasoned inner core",
      "Material: Leather",
      "In-Box Contents: 6 Cricket Balls",
      "Water-proofed",
    ],
    inStock: true,
    isTrending: true,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "India Women Jersey",
    price: "2099",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 4.3,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796128/cricify/women%27s-international/ind-women-jersey-front-1605_xhdizu.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796128/cricify/women%27s-international/ind-women-jersey-front-1605_xhdizu.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796128/cricify/women%27s-international/ind-women-jersey-front-1605_xhdizu.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: false,
    women: true,
    ipl: false,
    wpl: false,
    international: true,
  },
  {
    _id: uuid(),
    title: "RCB Unisex Fanwear Flip Flops - Red",
    price: "1189",
    categoryName: "merchandise",
    size: "One Size - Free Size",
    rating: 4.8,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/RCB_Unisex_Fanwear_Flip_Flops_-_Red-1189_hrwavi.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/RCB_Unisex_Fanwear_Flip_Flops_-_Red-1189_hrwavi.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796121/cricify/fan-merchandise/RCB_Unisex_Fanwear_Flip_Flops_-_Red-1189_hrwavi.jpg",
    ],
    description: [
      "Very comforting",
      "Fit Type: Regular",
      "Care Instructions:-Wipe with a clean dry cloth",
    ],
    inStock: true,
    isTrending: true,
    men: true,
    women: true,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "India Women Retro Jersey",
    price: "2299",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 4.6,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796128/cricify/women%27s-international/ind-women-jersey-retro-front-1905_zsin1a.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796128/cricify/women%27s-international/ind-women-jersey-retro-front-right-1905_glc4fx.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796128/cricify/women%27s-international/ind-women-jersey-retro-front-left-1905_busqn1.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: true,
    men: false,
    women: true,
    ipl: false,
    wpl: false,
    international: true,
  },
  {
    _id: uuid(),
    title: "SG Smart Cricket Helmet",
    price: "1899",
    categoryName: "gears",
    size: "One Size - Free Size",
    rating: 4.2,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_Smart_Cricket_Helmet-1899_uz5jaa.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_Smart_Cricket_Helmet-1899_uz5jaa.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_Smart_Cricket_Helmet-1899_uz5jaa.jpg",
    ],
    description: [
      "Polypropylene high-impact resistant outer shell",
      "Inner shell made from impact reducing foam",
      "Classic four vents for free flow air circulation",
      "Sweat absorbent lining",
      "High impact polypropylene shell",
      "Fully adjustable steel grill for superior protection",
      "Protective impact-resistant and sweat-absorbent with special sweat mesh breathable inner padding",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Gujarat Titans(GT) Jersey",
    price: "1599",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 4.8,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796158/cricify/ipl/gt-match-jersey-2023-hardik-1499-front_xlbg92.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796158/cricify/ipl/gt-match-jersey-2023-hardik-1499-back_e9mwyt.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796158/cricify/ipl/gt-match-jersey-2023-hardik-1499-back-front_oulpgs.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: true,
    men: true,
    women: false,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "SG R17 Grade 1 English Willow Cricket Bat",
    price: "40999",
    categoryName: "gears",
    size: "One Size - Free Size",
    rating: 4.9,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_R17_Grade_1_English_Willow_Cricket_Bat-40999_xhtqsp.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_R17_Grade_1_English_Willow_Cricket_Bat-40999_xhtqsp.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_R17_Grade_1_English_Willow_Cricket_Bat-40999_xhtqsp.jpg",
    ],
    description: [
      "Grade- Selected grade 1 world’s finest English willow hard pressed & traditionally shaped for superb stroke",
      "Grains- 8-10 straight grains",
      "Handle-Singapore cane handle with special 3 way insertion of cork in between splits for enhanced flexibility and shock absorption",
      "Handle Shape-Traditional round cane handle for supreme grip and overall bat control",
      "Weight-1160-1180 gm(2.9-2.10 lbs)",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: true,
    wpl: true,
    international: true,
  },
  {
    _id: uuid(),
    title: "Mumbai Indians(MI) Women Jersey",
    price: "1699",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796148/cricify/wpl/mi-women-match-jersey-2023-1499-front_nhp08b.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796147/cricify/wpl/mi-women-match-jersey-2023-1499-right-front_qr1dp1.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796147/cricify/wpl/mi-women-match-jersey-2023-1499-left-front_apzavu.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: true,
    men: false,
    women: true,
    ipl: false,
    wpl: true,
    international: false,
  },
  {
    _id: uuid(),
    title: "DSC IBIS 99 Kashmir Willow Cricket Bat",
    price: "4110",
    categoryName: "gears",
    size: "One Size - Free Size",
    rating: 4.5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796136/cricify/accessories/DSC_IBIS_99_Kashmir_Willow_Cricket_Bat-4110_ks0toy.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796136/cricify/accessories/DSC_IBIS_99_Kashmir_Willow_Cricket_Bat-4110_ks0toy.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796136/cricify/accessories/DSC_IBIS_99_Kashmir_Willow_Cricket_Bat-4110_ks0toy.jpg",
    ],
    description: [
      "Grade- Selected grade 1 world’s finest English willow hard pressed & traditionally shaped for superb stroke",
      "Grains- 8-10 straight grains",
      "Handle-Singapore cane handle with special 3 way insertion of cork in between splits for enhanced flexibility and shock absorption",
      "Handle Shape-Traditional round cane handle for supreme grip and overall bat control",
      "Weight-1160-1180 gm(2.9-2.10 lbs)",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "India 2003 WC Fan Jersey",
    price: "1999",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 4.2,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866681/cricify/ind-2003-wc-fan-jersey-1999_dmii5l.png",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866681/cricify/ind-2003-wc-fan-jersey-1999_dmii5l.png",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866681/cricify/ind-2003-wc-fan-jersey-1999_dmii5l.png",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: true,
  },
  {
    _id: uuid(),
    title: "MRF EW Genius Elite Cricket Bat Short Handle Virat Kohli Edition",
    price: "45999",
    categoryName: "gears",
    size: "One Size - Free Size",
    rating: 5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685939777/cricify/accessories/MRF_EW_Genius_Elite_Cricket_Bat_Short_Handle_Virat_Kohli_Edition-45999_oqoemb.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685939777/cricify/accessories/MRF_EW_Genius_Elite_Cricket_Bat_Short_Handle_Virat_Kohli_Edition-45999_oqoemb.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685939777/cricify/accessories/MRF_EW_Genius_Elite_Cricket_Bat_Short_Handle_Virat_Kohli_Edition-45999_oqoemb.jpg",
    ],
    description: [
      "Grade- Selected grade 1 world’s finest English willow hard pressed & traditionally shaped for superb stroke",
      "Grains- 8-10 straight grains",
      "Handle-Singapore cane handle with special 3 way insertion of cork in between splits for enhanced flexibility and shock absorption",
      "Handle Shape-Traditional round cane handle for supreme grip and overall bat control",
      "Weight-1160-1180 gm(2.9-2.10 lbs)",
    ],
    inStock: true,
    isTrending: true,
    men: true,
    women: true,
    ipl: true,
    wpl: true,
    international: true,
  },
  {
    _id: uuid(),
    title: "Delhi Capitals(DC) Jersey",
    price: "999",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 2.9,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796157/cricify/ipl/dc-match-jersey-2023-pant-999-front_k268cg.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796158/cricify/ipl/dc-match-jersey-2023-pant-999-back_jp7ex2.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796158/cricify/ipl/dc-match-jersey-2023-pant-999-back_jp7ex2.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: false,
    ipl: true,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "SG Club Leather Cricket Ball White",
    price: "5443",
    categoryName: "gears",
    size: "N/A",
    rating: 2.9,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_Club_Leather_Cricket_Ball_White_-_Pack_of_6-5443_w1c0cy.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_Club_Leather_Cricket_Ball_White_-_Pack_of_6-5443_w1c0cy.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/SG_Club_Leather_Cricket_Ball_White_-_Pack_of_6-5443_w1c0cy.jpg",
    ],
    description: [
      "Good quality centre construction encased with layers of top quality Portuguese cork wound with 100 percent wool",
      "Naturally seasoned inner core",
      "Material: Leather",
      "In-Box Contents: 6 Cricket Balls",
      "Water-proofed",
    ],
    inStock: true,
    isTrending: false,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "Delhi Capitals(DC) Women Jersey",
    price: "1199",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 4.5,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796147/cricify/wpl/dc-women-match-jersey-2023-1199-front_qurhd6.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796147/cricify/wpl/dc-women-match-jersey-2023-1199-front_qurhd6.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796147/cricify/wpl/dc-women-match-jersey-2023-1199-front_qurhd6.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: false,
    men: false,
    women: true,
    ipl: false,
    wpl: true,
    international: false,
  },
  {
    _id: uuid(),
    title: "Puma Mens Bowling 22.1 Cricket Shoe",
    price: "13999",
    categoryName: "gears",
    size: "One Size - Free Size",
    rating: 4.2,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796137/cricify/accessories/Puma_Mens_Bowling_22.1_Cricket_Shoe-front-13999_ufc7ff.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796136/cricify/accessories/Puma_Mens_Bowling_22.1_Cricket_Shoe-front-back-13999_fd2gfb.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685796136/cricify/accessories/Puma_Mens_Bowling_22.1_Cricket_Shoe-front-back-13999_fd2gfb.jpg",
    ],
    description: [
      "Sole: Rubber",
      "Closure: Lace-Up",
      "Fit Type: Regular",
      "Material:-Synthetic",
      "Care Instructions:-Wipe with a clean dry cloth",
    ],
    inStock: false,
    isTrending: false,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: false,
  },
  {
    _id: uuid(),
    title: "India Test Jersey",
    price: "1799",
    categoryName: "jerseys",
    size: "One Size - Free Size",
    rating: 4,
    images: [
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866682/cricify/ind-test-jersey-front-799_l34usd.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866681/cricify/ind-test-jersey-side-front-799_q9jt4o.jpg",
      "https://res.cloudinary.com/dbe8yf165/image/upload/v1685866681/cricify/ind-test-jersey-side-front-799_q9jt4o.jpg",
    ],
    description: [
      "Fit Type: Regular Fit",
      "Very comforting",
      "100% polyester",
      "Wash:- Gentle Hand Wash, Do Not Bleach, Dry in Shade",
    ],
    inStock: true,
    isTrending: true,
    men: true,
    women: true,
    ipl: false,
    wpl: false,
    international: true,
  },
];
